export const isPositiveNumericString = (number: string): boolean =>
  !isNaN(+number) && +number > 0
